import { render, staticRenderFns } from "./LexonMaskComponent.vue?vue&type=template&id=2dc020ce&scoped=true&lang=pug"
import script from "./LexonMaskComponent.vue?vue&type=script&lang=ts"
export * from "./LexonMaskComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonMaskComponent.vue?vue&type=style&index=0&id=2dc020ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc020ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc020ce')) {
      api.createRecord('2dc020ce', component.options)
    } else {
      api.reload('2dc020ce', component.options)
    }
    module.hot.accept("./LexonMaskComponent.vue?vue&type=template&id=2dc020ce&scoped=true&lang=pug", function () {
      api.rerender('2dc020ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonMask/LexonMaskComponent.vue"
export default component.exports